module.exports = __webpack_public_path__ + "static/img/game6.848d5a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleFestival/3/game6.png
// module id = Y3J7
// module chunks = 1